import { BlotterDensity, BlotterTable, useBlotterObservables, useBlotterTable } from '@talos/kyoko';
import type { SignalsValueFormatter } from '../core';
import type { RelativePerformanceTableRow } from './Comparison.types';
import { useComparisonTableColumns } from './useComparisonTableColumns';

interface ComparisonTableProps {
  rows: RelativePerformanceTableRow[];
  formatMetricValue: SignalsValueFormatter;
  rowColors: ReadonlyMap<string, string>;
  metricDisplayName: string;
}

export function ComparisonTable({ rows, formatMetricValue, rowColors, metricDisplayName }: ComparisonTableProps) {
  const { dataObservable } = useBlotterObservables<RelativePerformanceTableRow>({ data: rows });
  const columns = useComparisonTableColumns({ formatMetricValue, rowColors, metricDisplayName });

  const blotterTable = useBlotterTable<RelativePerformanceTableRow>({
    dataObservable,
    errorObservable: undefined,
    rowID: 'cmAssetId' satisfies keyof RelativePerformanceTableRow,
    density: BlotterDensity.VeryComfortable,
    columns,
  });

  return <BlotterTable {...blotterTable} />;
}
